import { PageHeader } from '../layout/page-header'
import { pagePanel, pagePanelBody } from '../layout/page-styles'
import { cn } from '../../lib/utils'

interface FormContainerProps {
  title: string
  subtitle: string
  children: React.ReactNode
  onSubmit: (e: React.FormEvent) => void
  className?: string
}

export function FormContainer({
  title,
  subtitle,
  children,
  onSubmit,
  className = '',
}: FormContainerProps) {
  return (
    <div className={cn('max-w-2xl mx-auto w-full', className)}>
      <PageHeader title={title} subtitle={subtitle} className='mb-6' />

      <form onSubmit={onSubmit} className='space-y-6'>
        <div className={cn(pagePanel, pagePanelBody)}>{children}</div>
      </form>
    </div>
  )
}
